export default "__VITE_ASSET__DI2L0qyy__"